import { Modal, useSession } from '@cfs-fixings/shared'
import CreateProjectForm from '../../forms/projects/CreateProjectForm'
import { ProjectResource, UserWithCustomerResource, useGetAuthSessionQuery } from '@/api/serverApi'

const textSpec = {
  title: 'New Project',
  buttonLabels: {
    cancel: 'Cancel',
    create: 'Create Project',
  },
}

type PropTypes = {
  isOpen: boolean
  onSuccess?: (project?: ProjectResource) => void
  onClose: () => void
}

const CreateProjectModal = ({ isOpen, onSuccess, onClose }: PropTypes) => {
  const { user } = useSession({ getData: useGetAuthSessionQuery })

  return (
    <Modal
      size="sm"
      isOpen={isOpen}
      onClose={onClose}
      title={textSpec.title}
      content={
        user
          ? (
            <CreateProjectForm
              customerId={(user.data as UserWithCustomerResource).customer.id}
              onCompleted={(project) => {
                onSuccess?.(project)
                onClose()
              }}
              onClose={onClose}
            />
          )
          : <></>
      }
    />
  )
}

export default CreateProjectModal
